export default __webpack_public_path__ + "static/media/Crescents_02.fcf410fe.png";